/**
 * Notifications data access (AGENTS.md §2: UI modules must not call
 * supabase.from() directly). Serves src/notifications.tsx's list fetch and
 * mark-read / soft-delete / delete mutations with the exact same tables,
 * predicates, and limits as the former inline calls.
 */
import { supabase } from '../supabase';

/** Fetch the newest 50 notifications addressed to any of my mention names. */
export function fetchNotificationsForNames(tenantId: string | null | undefined, mentionedNames: string[]) {
  return supabase.from('notifications')
    .select('*')
    .eq('tenant_id', tenantId)
    .in('mentioned_name', mentionedNames)
    .order('created_at', { ascending: false })
    .limit(50);
}

/** Mark one notification read. */
export function markNotificationRead(tenantId: string | null | undefined, id: string) {
  return supabase.from('notifications')
    .update({ read: true }).eq('tenant_id', tenantId).eq('id', id);
}

/** Mark a batch of notifications read. */
export function markNotificationsRead(tenantId: string | null | undefined, ids: string[]) {
  return supabase.from('notifications')
    .update({ read: true }).eq('tenant_id', tenantId).in('id', ids);
}

/** Read one notification's data JSONB (soft-delete read path, single row). */
export function fetchNotificationById(tenantId: string | null | undefined, id: string) {
  return supabase.from('notifications')
    .select('data').eq('tenant_id', tenantId).eq('id', id).single();
}

/** Soft-delete: append the current user to data.deletedBy. */
export function updateNotificationDeletedBy(
  tenantId: string | null | undefined,
  id: string,
  data: Record<string, unknown>,) {
  return supabase.from('notifications').update({
    data,
  }).eq('tenant_id', tenantId).eq('id', id);
}

/** Hard-delete a batch of notifications (admin history clear). */
export function deleteNotifications(tenantId: string | null | undefined, ids: string[]) {
  return supabase.from('notifications')
    .delete().eq('tenant_id', tenantId).in('id', ids);
}
